<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="站点授权">
                <div class="site-container">
                    <div >
                        <el-checkbox label="全选" v-model="checkAll" @change="handleCheckAllChange" :disabled="forbidden"></el-checkbox>
                        <span class="remark">注:勾选全选后,新增站点后会自动增加对应站点权限</span>
                    </div>
                    <div class="item" v-for="(item, key) in data" :key="key">
                        <div class="check-all">
                            <el-checkbox :label="item.name" @change="e => handleCheckGroupChange(e, item, key)" v-model="checkedMenu[key]" :disabled="forbidden"></el-checkbox>
                        </div>
                        <el-checkbox-group v-model="checkGroups[key]" @change="e => handleCheckItemChange(e, item, key)">
                            <div class="check-item-list">
                                <el-checkbox :label="tag.name" :value="tag.id" v-for="(tag, key) in item.children" :key="key" :disabled="forbidden"></el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                    <div>
                        <el-button type="primary" @click="submitForm()" v-if="typeId==0">保存</el-button>
                        <el-button @click="$router.back()" v-if="typeId==0">取消</el-button>
                        <el-button @click="$router.back()" v-if="typeId==1">返回</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import {getUserInfo} from '@/utils/auth'
    import { getSite } from '@/service/site'
    import {getQueryObject} from '@/utils/index'
    import {setAdminSites} from '@/service/user'
    export default {
        name: "SitesSet",
        data () {
            return {
                typeId:null,
                forbidden:null,
                checkAll: false,
                data: [],
                siteAll : {},
                checkGroups: {
                    0: [],
                    1: [],
                    2: []
                },
                checkedMenu: {
                    0: '',
                    1: '',
                    2: ''
                }
            }
        },
        mounted () {

            this.initData()
        },
        methods: {
            async initData(){
                let query = getQueryObject()
                if (!query.id) {
                    this.$router.push('list')
                }
                this.typeId=query.type
                if(query.type==1){
                    this.forbidden=true;
                }
                let user = JSON.parse(getUserInfo())
                if (!user.sites || user.sites.length == 0) {
                    this.$router.push('list')
                }
                this.checkGroups = {
                    0: [],
                    1: [],
                    2: [],
                    3: [],
                    4: []
                }
                this.checkedMenu = {
                    0: '',
                    1: '',
                    2: '',
                    3: '',
                    4: ''
                }
                let sitesQuery = {
                    'per_page' : 9999
                }
                let siteAll = {}
                let sitesAlreadyHave = []
                await getSite(sitesQuery).then((data) => {
                    for(let i in data.data) {
                        siteAll[data.data[i].id] = {
                            id: data.data[i].id,
                            name: data.data[i].name,
                            pinyin : data.data[i].pinyin,
                        }
                    }
                })
                if (user.sites[0] != '*') {
                    for (let i in user.sites) {
                        let site = siteAll[user.sites[i]]
                        this.siteAll[site.name] = site
                    }
                } else {
                    for (let i in siteAll) {
                        let site = siteAll[i]
                        this.siteAll[site.name] = site
                    }
                }
                if (query.site_str && query.site_str !== '*') {
                    sitesAlreadyHave = query.site_str.split("_")
                } else if (query.site_str && query.site_str === '*') {
                    sitesAlreadyHave = []
                    for (let i in this.siteAll) {
                        sitesAlreadyHave.push(this.siteAll[i].id)
                    }
                }
                let data = []
                for (let i = 65; i < 91; i+=5) {
                    let name = ''
                    for (let j = 0; j < 5; j++) {
                        if ((i+j) < 91) {
                            name += String.fromCharCode((j+i))
                        }
                    }
                    if (i == 85) {
                        name += String.fromCharCode(90)
                        data.push({
                            id: i,
                            name: name,
                            children: [
                            ]
                        })
                        i++
                    } else {
                        data.push({
                            id: i,
                            name: name,
                            children: [
                            ]
                        })
                    }
                }

                for (let i in this.siteAll) {
                    let site = this.siteAll[i]
                    let char = site.pinyin.substr(0, 1).toUpperCase()
                    let charCode = char.charCodeAt()
                    if (charCode >= 85) {
                        data[4].children.push(site)
                    }  else if (charCode >= 80) {
                        data[3].children.push(site)
                    }  else if (charCode >= 75) {
                        data[2].children.push(site)
                    }  else if (charCode >= 70) {
                        data[1].children.push(site)
                    }  else if (charCode >= 65) {
                        data[0].children.push(site)
                    }
                }
                this.data = data
                for (let i in sitesAlreadyHave) {
                    if (siteAll[sitesAlreadyHave[i]]) {
                        let site = siteAll[sitesAlreadyHave[i]]
                        let char = site.pinyin.substr(0, 1).toUpperCase()
                        let charCode = char.charCodeAt()
                        if (charCode >= 85) {
                            this.checkGroups[4].push(site.name)
                        }  else if (charCode >= 80) {
                            this.checkGroups[3].push(site.name)
                        }  else if (charCode >= 75) {
                            this.checkGroups[2].push(site.name)
                        }  else if (charCode >= 70) {
                            this.checkGroups[1].push(site.name)
                        }  else if (charCode >= 65) {
                            this.checkGroups[0].push(site.name)
                        }
                    }
                }
            },
            getCheckedNodes(){
                let rel = []
                let total = []
                for (let i in this.checkGroups) {
                    total = total.concat(this.checkGroups[i])
                }
                for (let i in total) {
                    if (this.siteAll[total[i]]) {
                        let site = this.siteAll[total[i]]
                        rel.push(site.id)
                    }
                }
                return rel
            },
            submitForm(){
                let query = getQueryObject()
                if (!query.id) {
                    this.$router.push('list')
                }
                let param = {
                    sites : this.getCheckedNodes()
                }
                setAdminSites(query.id, param).then((data) => {
                    this.$message({
                        message: '修改成功',
                        type: 'success',
                        duration: 3 * 1000
                    })
                    this.$router.push('list')
                }).catch(err => {
                    this.$message({
                        message: err.message || '修改失败',
                        type: 'error',
                        duration: 3 * 1000
                    })
                })
            },
            /** 改变整体全选触发 */
            handleCheckAllChange (status) {
                this.data.map((item, index) => {
                    const data = item.children.map(v => v.name)
                    this.$set(this.checkGroups, index, status ? data : [])
                    this.$set(this.checkedMenu, index, status)
                })
            },
            /** 改变一组子节点触发 */
            handleCheckGroupChange (status, item, key) {
                const data = item.children.map(v => v.name)
                this.$set(this.checkGroups, key, status ? data : [])
                this.dealCheckAll()
            },
            /** 改变单个子节点触发 */
            handleCheckItemChange (e, item, index) {
                if (!status) this.checkAll = false
                if (this.checkGroups[index].length === item.children.length) {
                    this.$set(this.checkedMenu, index, true)
                } else {
                    this.$set(this.checkedMenu, index, false)
                }
                this.dealCheckAll()
                console.log(this.checkGroups)
            },
            /** 判断页面总选中状态 */
            dealCheckAll (status) {
                const size = this.data.map(v => v.children.length).reduce((total, num) => total + num)
                const checkedSize = Object.keys(this.checkGroups).map(v => this.checkGroups[v].length).reduce((total, num) => total + num)
                this.checkAll = size === checkedSize
            }
        }
    }
</script>
<style scoped lang="less">
    .site-container{
        background: #FFF;
        padding: 20px 30px;
        .remark{
            font-size: 12px;
            color: #999;
            margin-left: 15px;
        }
        .item{
            margin-top: 30px;
            .check-all{
                background: #fafafa;
                line-height: 45px;
                padding: 0 20px 0;
            }
            .check-item-list{
                padding: 20px;
                .el-checkbox{
                    margin-bottom: 10px;
                }
            }
        }
    }
</style>
